"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SLProProcessor = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const react_1 = require("react");
const SimpleTrading_1 = require("../SimpleTrading");
const trade_utils_lib_1 = require("trade_utils_lib");
const GridTradingUtils_1 = require("../GridTrading/GridTradingUtils");
exports.SLProProcessor = {
    useUserParams: (side, trigglePrice, price, amount, investPercent, baseAvailable, quoteAvailable, symbol, orderType, baseTotalBalance, leverageCoinInfo) => {
        const minAmount = (0, react_1.useMemo)(() => {
            const min = SimpleTrading_1.SimpleTrading.getMinAmount(symbol, new trade_utils_lib_1.SafeDecimal(price).toNumber());
            return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(min, symbol.amount);
        }, [symbol, price]);
        const [balance, balanceUnit] = (0, react_1.useMemo)(() => {
            if (side === TradeAPILib_1.ExchangeOrderSide.buy) {
                const b = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(quoteAvailable, symbol.precision);
                return [b, symbol.quote];
            }
            else {
                const b = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(baseAvailable, symbol.amount);
                return [b, symbol.baseDisplay];
            }
        }, [side, symbol, quoteAvailable, baseAvailable]);
        const [parseInvest, parsePercent] = SimpleTrading_1.SimpleTrading.useInvestAndInvestPercent(price, amount, investPercent, side, balance, symbol);
        const volume = (0, react_1.useMemo)(() => {
            if (!price || !parseInvest) {
                return "0";
            }
            const value = new trade_utils_lib_1.SafeDecimal(price).mul(new trade_utils_lib_1.SafeDecimal(parseInvest));
            return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(value, symbol.precision);
        }, [price, parseInvest, symbol.precision]);
        const investState = (0, react_1.useMemo)(() => {
            const state = {
                state: "normal",
                min: minAmount + `(${symbol.baseDisplay})`,
                max: balance +
                    `(${side === TradeAPILib_1.ExchangeOrderSide.buy ? symbol.quote : symbol.baseDisplay})`,
            };
            if (parseInvest && Number(volume)) {
                if (new trade_utils_lib_1.SafeDecimal(parseInvest).lessThan(new trade_utils_lib_1.SafeDecimal(minAmount))) {
                    state.state = "small";
                }
                if (side === TradeAPILib_1.ExchangeOrderSide.buy) {
                    if (new trade_utils_lib_1.SafeDecimal(volume).greaterThan(new trade_utils_lib_1.SafeDecimal(balance))) {
                        state.state = "large";
                    }
                }
                else {
                    if (new trade_utils_lib_1.SafeDecimal(parseInvest).greaterThan(balance)) {
                        state.state = "large";
                    }
                }
            }
            return state;
        }, [volume, minAmount, balance, side, parseInvest, symbol.symbol]);
        const emptyErrors = (0, react_1.useMemo)(() => {
            const emptys = [];
            if (!Number(trigglePrice)) {
                emptys.push("order_trigger_price");
            }
            if (!Number(price)) {
                const priceStr = side === TradeAPILib_1.ExchangeOrderSide.buy
                    ? "trade_buy_price"
                    : "trade_sell_price";
                emptys.push(priceStr);
            }
            if (!Number(parseInvest)) {
                const amountStr = side === TradeAPILib_1.ExchangeOrderSide.buy
                    ? "trade_buy_amount"
                    : "trade_sell_amount";
                emptys.push(amountStr);
            }
            return emptys;
        }, [trigglePrice, price, parseInvest, side]);
        return {
            orderType,
            side,
            price,
            trigglePrice,
            investPercent: parsePercent,
            amount: parseInvest,
            balance,
            balanceUnit,
            symbol,
            investState,
            minInvest: minAmount,
            volume,
            emptyErrors,
            baseTotalBalance,
            leverageCoinInfo,
        };
    },
    getCreateOrderRequest: (params, currentPrice, $st) => {
        if (params.emptyErrors.length > 0) {
            throw $st("trade_params_not_fill_enough");
        }
        const symbol = params.symbol;
        if (params.investState.state === "small") {
            throw $st("trade_error_low_amount", {
                amount: `${params.minInvest} ${symbol.baseDisplay}`,
            });
        }
        else if (params.investState.state === "large") {
            throw $st("trade_error_balance_not_enough");
        }
        if (!currentPrice) {
            throw $st("trade_query_ticker_error");
        }
        if (params.side === TradeAPILib_1.ExchangeOrderSide.buy && params.leverageCoinInfo) {
            const tradeCost = new trade_utils_lib_1.SafeDecimal(params.price).mul(params.amount);
            const currentLeveragePosition = new trade_utils_lib_1.SafeDecimal(params.baseTotalBalance)
                .mul(params.price)
                .add(tradeCost);
            if (tradeCost.greaterThan(params.leverageCoinInfo.quota)) {
                throw $st("trade_cost_than_leverage_amount", {
                    amount: params.leverageCoinInfo.quota,
                });
            }
            else if (currentLeveragePosition.greaterThan(params.leverageCoinInfo.accountQuota)) {
                throw $st("trade_cost_than_leverage_pair_limit", {
                    amount: params.leverageCoinInfo.accountQuota,
                });
            }
        }
        SimpleTrading_1.SimpleTrading.parseAmountSupportTrading(params.amount, symbol, params.price, $st);
        const condition_direction = GridTradingUtils_1.GridTradingUtils.getConditionDirectionWithFormatterError(params.trigglePrice, currentPrice, $st) || "1";
        return {
            type: params.orderType,
            base: symbol.base,
            quote: symbol.quote,
            side: params.side,
            condition: params.trigglePrice,
            condition_direction: condition_direction,
            conditionType: "limit",
            price: params.price,
            amount: params.amount,
            quantity: null,
        };
    },
};
